<script setup lang="ts">
import { ref } from "vue";
import Button from "../../base-components/Button/Button.vue";
import EstadisticasFiltros from "./components/EstadisticasFiltros.vue";
import EstadisticasRubros from "./components/EstadisticasRubros.vue";
import EstadisticasProductos from "./components/EstadisticasProductos.vue";
import EstadisticasMesas from "./components/EstadisticasMesas.vue";
import EstadisticasDescuentos from "./components/EstadisticasDescuentos.vue";
import { userUserStore } from "../../stores/user";

const userStore = userUserStore();

const showFormFiltro = ref(false);
</script>

<template>
  <div v-if="!showFormFiltro" class="mt-4">
    <Button
      class="w-full border-slate-300"
      variant="secondary"
      size="lg"
      @click="
        () => {
          showFormFiltro = true;
        }
      "
    >
      <div class="p-3 flex items-center">
        <i class="fas fa-arrow-left mr-2"></i>
        <h2 class="text-lg" style="text-align: left">Filtros</h2>
      </div>
    </Button>
  </div>
  <div v-else class="mt-5">
    <EstadisticasFiltros
      @cerrar="
        () => {
          showFormFiltro = false;
        }
      "
    />
  </div>
  <EstadisticasRubros />
  <EstadisticasProductos />
  <EstadisticasMesas />
  <EstadisticasDescuentos
    v-if="userStore.opcionesGenerales.descuentos.length"
  />
</template>
